import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ChangedDocumentService, DocumentListService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { ComponentDefinition } from '@formbird/types';
import { SearchResultsProcessor } from '@formbird/shared';
import { BehaviorSubject, Subscription, from } from 'rxjs';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { sclHandlebars } from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as uuid from 'uuid';
  
interface gridColumn {
  displayName: string;
  expression: string;
  valueOnDrop?: any;
  sort?: {
    type?: string;
    direction?: 'Ascending' | 'Descending';
    enforced?: boolean;
    expression?: string;
    collapsible?: boolean;
  };
  dragRestrictions?: {
    allowed?: number[] | null;
    notAllowed?: number[] | null;
  };
}
interface cardTableComponentDefinition extends ComponentDefinition {
  filter: string;
  cardDisplay?: string;
  cardTemplate?: string;
  label?: string;
  minCardWidth?: string;
  columnField?: string;
  gridColumns?: gridColumn[];
  groupingField?: string;
  gridGrouping?: gridColumn[];
  disableSave: boolean
  autoSave:boolean;
  cardTableSave:boolean;
  delayedDragging:number;
  height: number;


}
@Component({
  templateUrl: './card-table.component.html',
  styleUrls: ['./card-table.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardTableComponent extends AbstractComponent<cardTableComponentDefinition> implements OnInit, OnDestroy {
  searchClientService: any;
  options: any ;
  totalResults = 0;
  loading = false;
  subs = new Subscription();
  docs: any = [];
  dataSubject = new BehaviorSubject<any[]>([]);
  label: string;
  minCardWidth: string;
  groups: any;
  columnField: string;
  gridColumns: gridColumn[] | null;
  gridGrouping: gridColumn[] | null;
  groupingField: string;
  rankingField: string;
  editingCardId: string | null;
  disableSave: boolean
  autoSave:boolean;
  cardTableSave:boolean;
   height: string;
  currentDragId:string;
  delayedDragging:number;
  dragDelayElapsed: boolean = false;
  private dragTimeout: any;
  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    private documentListService: DocumentListService,
    protected cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
   ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cd);
    this.searchClientService = this.formbirdInjectorService.get('SearchClientService');
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.options = {
      sourceFilter: {include:['documentId', 'systemHeader.summaryName', 'rankingField']},
      filter: {},
      includeDeleted: false,
      searchOfflineOnly: false,
    };
    this.label = this.componentDefinition.label ? this.componentDefinition.label : '';
    this.minCardWidth = this.componentDefinition.minCardWidth ? this.componentDefinition.minCardWidth : '100';
    this.columnField = this.componentDefinition.columnField ? this.componentDefinition.columnField : '';
    this.gridColumns = this.componentDefinition.gridColumns ? this.componentDefinition.gridColumns : null;
    this.gridGrouping = this.componentDefinition.gridGrouping ? this.componentDefinition.gridGrouping : null;
    this.groupingField = this.componentDefinition.groupingField ? this.componentDefinition.groupingField : '';
    this.disableSave = this.componentDefinition.disableSave? this.componentDefinition.disableSave: false;
    this.autoSave = this.componentDefinition.autoSave? this.componentDefinition.autoSave: false;
    this.cardTableSave = this.componentDefinition.cardTableSave? this.componentDefinition.cardTableSave:false;
    this.height = this.componentDefinition.height? this.componentDefinition.height + 'px': 'max-content';
    this.delayedDragging = this.componentDefinition.delayedDragging? this.componentDefinition.delayedDragging: 0;
      this.loading = false;
    this.initialize()

  }

  initialize(){
    if(this.document[this.fieldName]){
       this.groups = this.document[this.fieldName] ;
       this.cdr.detectChanges()
    }else{
      this.loadData();
     }
  }

  loadData() {
    if (this.componentDefinition.filter) {
      this.loading = true;
      const cardTableConfig = this;
      this.extractFieldNames()
      this.processElasticQuery();
      const dataSub = from(this.searchClientService.search(cardTableConfig.options)).subscribe(
        (data: any) => {
          if (data) {
            this.handleSearchResults(data);
            this.dataSubject.next(data);
          } else {
            this.dataSubject.next([]);
            this.totalResults = 0;
            this.docs = [];
            this.loading = false;
            this.cdr.detectChanges();
          }
        },
        (err) => {
          this.handleError(err);
          this.dataSubject.next([]);
          this.loading = false;
          this.cdr.detectChanges();
        }
      );

      this.subs.add(dataSub);
    }
  }


  extractFieldNames() {
    const handlebarsExpressions = this.extractHandlebarsExpressions(this.componentDefinition);
    const fieldsToInclude = this.getFieldsFromHandlebars(handlebarsExpressions);
    this.options.sourceFilter.include = [...new Set([...this.options.sourceFilter.include, ...fieldsToInclude])];
  }

  extractHandlebarsExpressions(componentDefinition: any): string[] {
    const handlebarsRegex = /{{\s*[^}]+\s*}}/g;
    const fieldsWithHandleBars: string[] = [
      componentDefinition?.cardDisplay || "",
      componentDefinition?.cardTemplate || "",
      ...this.gridColumns?.map(col => col?.expression || "") || [],
      ...this.gridColumns?.map(col => col?.sort?.expression || "") || [],
      ...this.gridGrouping?.map(group => group?.expression || "") || [],
      ...this.gridGrouping?.map(group => group?.sort?.expression || "") || [],
    ];

    return fieldsWithHandleBars.reduce((acc, expression) => {
      const matches = expression.match(handlebarsRegex);
      if (matches) acc.push(...matches.map(match => match.trim()));
      return acc;
    }, []);
  }

  getFieldsFromHandlebars(expressions: string[]): string[] {
    const fieldsToInclude = expressions.map(expression => {
      const match = expression.split('.');
      return match[1]?.replace('}}', '').trim();
    }).filter(field => field);

    if (this.columnField && !fieldsToInclude.includes(this.columnField)) {
      fieldsToInclude.push(this.columnField);
    }
    if (this.groupingField && !fieldsToInclude.includes(this.groupingField)) {
      fieldsToInclude.push(this.groupingField);
    }
    
    return fieldsToInclude;
  }


  findConnectedLists(groupIndex) {
    if(this.groups){
      return  this.groups
      .filter((_, index) => index !== groupIndex)
      .flatMap((group) => group.columns)
      .map((column) => column.colId);
    }

  }

  evaluateHandlebarsExpression(handleBarsexpression, doc, filter?: boolean) {
    let expression = this.processHandlebars(handleBarsexpression, doc);
    if (filter) {
      try {
        const fun = new Function(`return (${expression});`);
        return fun();
      } catch (err) {
        return false;
      }
    }
    return expression;
  }

  handleSearchResults(data: any) {
    if (data) {
      SearchResultsProcessor.processSearchResults(
        data,
        (hit) => {},
        (hits) => {
          this.totalResults = hits.length;
          this.docs = hits;
          this.groups = this.organizeIntoGroups();
          this.cdr.detectChanges();
        }
      );
    }
    this.loading = false;
    this.cdr.detectChanges();
  }

  handleError(err: any) {
    this.docs = [];
    this.loading = false;
  }

  displayCard(doc: any): SafeHtml {
    if (this.componentDefinition.cardTemplate) {
      let cardData = this.processHandlebars(this.componentDefinition.cardTemplate, doc);
      return this.sanitizer.bypassSecurityTrustHtml(cardData);
    } else if (this.componentDefinition.cardDisplay) {
      let cardData = this.processHandlebars(this.componentDefinition.cardDisplay, doc);
      return this.sanitizer.bypassSecurityTrustHtml(cardData);
    } else {
      return this.sanitizer.bypassSecurityTrustHtml(doc.systemHeader.summaryName);
    }
  }

  organizeIntoGroups() {
    if (this.gridGrouping) {
      return this.gridGrouping.map((gridGroup, index) => {
        let groupDocs = this.docs.filter((doc) => this.evaluateHandlebarsExpression(gridGroup.expression, doc, true));
        if (gridGroup?.sort && gridGroup?.sort?.expression) {
          this.sort(groupDocs, gridGroup.sort);
        }
        let columns = this.getColumns(groupDocs, index);
        let collapsible = gridGroup?.sort?.collapsible ? gridGroup?.sort?.collapsible : false;
        return { grpHeader: gridGroup.displayName, columns: columns, collapsible: collapsible };
      });
    } else if (this.groupingField) {
      const groupMap = new Map<string, Document[]>();

      this.docs.forEach((doc) => {
        const groupValue = doc[this.groupingField];
        if (!groupMap.has(groupValue)) {
          groupMap.set(groupValue, []);
        }
        groupMap.get(groupValue).push(doc);
      });

      return Array.from(groupMap.entries()).map(([groupValue, docs], index) => ({
        grpHeader: groupValue,
        columns: this.getColumns(docs, index),
        collapsible: false,
      }));
    } else {
      return [{ grpHeader: '', columns: this.getColumns(this.docs, 0), collapsible: false }];
    }
  }

  getColumns(docs, groupIndex) {
    if (this.gridColumns) {
      return this.gridColumns.map((gridColumn, index) => {
        let columnDocs = docs.filter((doc) => this.evaluateHandlebarsExpression(gridColumn.expression, doc, true));
        if (gridColumn?.sort && gridColumn?.sort?.expression) {
          this.sort(columnDocs, gridColumn.sort);
        }
        //rank column
        columnDocs = this.rankDocs(columnDocs);

        let collapsible = gridColumn?.sort?.collapsible ? gridColumn?.sort?.collapsible : false;
        return {
          colId: this.generateId(index, groupIndex),
          colHeader: gridColumn.displayName,
          docs: columnDocs,
          collapsible: collapsible,
          connectedLists: this.findConnectedLists(groupIndex)
        };
      });
    } else if (this.columnField) {
      const columns = {};
      docs.forEach((doc) => {
        const columnValue = doc[this.columnField];
        if (!columns[columnValue]) {
          columns[columnValue] = [];
        }
        columns[columnValue].push(doc);
      });
       let result =  Object.keys(columns).map((key, index) => ({
        colId: this.generateId(index, groupIndex),
        colHeader: key,
        docs: this.rankDocs(columns[key]),
        collapsible: false,
        connectedLists: this.findConnectedLists(groupIndex)
      }));

      return result;
    } else {
      docs = this.rankDocs(docs);
      return [{ colId: this.generateId(0, groupIndex), colHeader: '', docs: docs, collapsible: false, connectedLists: this.findConnectedLists(groupIndex) }];
    }
  }
  sort(docs, sortOptions) {
    docs.sort((a, b) => {
      let expression = sortOptions.expression ? sortOptions.expression : '{{doc.systemHeader.summaryName}}';
      let valueA = this.evaluateHandlebarsExpression(expression, a);
      let valueB = this.evaluateHandlebarsExpression(expression, b);
      if (sortOptions.type === 'numeric') {
        return sortOptions.direction === 'Ascending' ? Number(valueA) - Number(valueB) : Number(valueB) - Number(valueA);
      } else if (sortOptions.type === 'date') {
        return sortOptions.direction === 'Ascending'
          ? new Date(valueA).getTime() - new Date(valueB).getTime()
          : new Date(valueB).getTime() - new Date(valueA).getTime();
      } else {
        return sortOptions.direction === 'Ascending' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }
    });
  }
  dropCard(event: CdkDragDrop<any[]>, column, group) {
    this.dragDelayElapsed = false;
    this.clearDragTimeout()
    this.cdr.detectChanges()
    let prevColumnRep = [...event.container.data]
    const [currentGroupIndex, curentColumnIndex] = this.extractIndex(event.container.id);
    const [prevGroupIndex, prevColumnIndex] = this.extractIndex(event.previousContainer.id);
    const droppedCard = event.item.data;
    const gridColumn = this.gridColumns && this.gridColumns[curentColumnIndex];
    const gridGroup = this.gridGrouping && this.gridGrouping[currentGroupIndex];
    if (gridColumn && gridColumn?.dragRestrictions) {
      if (
        (gridColumn.dragRestrictions.allowed && !gridColumn.dragRestrictions.allowed.includes(prevColumnIndex)) ||
        (gridColumn.dragRestrictions.notAllowed && gridColumn.dragRestrictions.notAllowed.includes(prevColumnIndex))
      ) {
        return;
      }
    }

    if (gridGroup && gridGroup?.dragRestrictions) {
      if (
        (gridGroup.dragRestrictions.allowed && !gridGroup.dragRestrictions.allowed.includes(prevGroupIndex)) ||
        (gridGroup.dragRestrictions.notAllowed && gridGroup.dragRestrictions.notAllowed.includes(prevGroupIndex))
      ) {
        return;
      }
    }

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }

    if (this.columnField && gridColumn?.valueOnDrop) {
      droppedCard[this.columnField] = gridColumn.valueOnDrop;
       this.cdr.detectChanges();
    }
    if (this.groupingField && gridGroup?.valueOnDrop) {
      droppedCard[this.groupingField] = gridGroup.valueOnDrop;
       this.cdr.detectChanges();
    }
    //format the columns again
    if (currentGroupIndex != prevGroupIndex) {
      //current group
      let header = group.grpHeader;
      let collapsible = group.collapsible;
      let docs = group.columns.flatMap((col) => col.docs);
      this.groups[currentGroupIndex] = {
        grpHeader: header,
        columns: this.getColumns(docs, currentGroupIndex),
        collapsible: collapsible,
      };
       this.cdr.detectChanges();
    }

    if (gridGroup && gridGroup.sort && gridGroup.sort.enforced) {
      let groupDocs = group.columns.flatMap((col) => col.docs);
      this.sort(groupDocs, gridGroup.sort);
      let header = group.grpHeader;
      let collapsible = group.collapsible;
      this.groups[currentGroupIndex] = {
        grpHeader: header,
        columns: this.getColumns(groupDocs, currentGroupIndex),
        collapsible: collapsible,
      };
       this.cdr.detectChanges();
    }

     this.adjustCardRanking(droppedCard, column)

    if (gridColumn && gridColumn.sort && gridColumn.sort.enforced) {
      let unRankedCards = column.docs.filter((doc) => this.rankExpression(doc.rankingField, false));
      let rankedCards = column.docs.filter((doc) => this.rankExpression(doc.rankingField, true));

      this.sort(unRankedCards, gridColumn.sort);
      column.docs = [...rankedCards, ...unRankedCards];
       this.cdr.detectChanges();
    }

     if(this.disableSave) return;
     if(this.cardTableSave && this.hasColRepChanged(prevColumnRep, column.docs)){
      this.valueChanged(this.groups)
     }
 
  }

 

  adjustCardRanking(droppedCard: any, column: any) {
    let curCardRank = Number(droppedCard.rankingField);
    if (!isNaN(curCardRank) && curCardRank > 0) {
      let index = column.docs.findIndex((el) => el === droppedCard);
      let cardsAbove = column.docs.slice(0, index);
      let cardsBelow = column.docs.slice(index + 1, column.docs.length);

      cardsAbove.reverse().forEach((card) => {
        let prevCardRank = curCardRank;
        let cardRank = Number(card.rankingField);
        if (!isNaN(cardRank) && cardRank > prevCardRank) {
           let diff = cardRank - prevCardRank;
          let finalCardRank = cardRank - diff;
          card.rankingField = finalCardRank - 1 < 1 ? finalCardRank : finalCardRank - 1;
        } else if (isNaN(cardRank)) {
           let finalCardRank = curCardRank;
          card.rankingField = finalCardRank - 1 < 1 ? finalCardRank : finalCardRank - 1;
        }
      });

      cardsBelow.forEach((card) => {
        let cardRank = Number(card.rankingField);
        let prevCardRank = curCardRank;
        if (!isNaN(cardRank) && cardRank < prevCardRank) {
           card.rankingField = prevCardRank + 1;
        }
      });

      column.docs = [...cardsAbove.reverse(), droppedCard, ...cardsBelow];
    }


    if (isNaN(curCardRank)) {
      let index = column.docs.findIndex((el) => el === droppedCard);
      let cardsAbove = column.docs.slice(0, index);
      let cardsBelow = column.docs.slice(index + 1, column.docs.length);
      let prevRankingField = cardsAbove.length > 0 ? Number(cardsAbove[cardsAbove.length - 1].rankingField) : NaN;
      let nextRankingField = cardsBelow.length > 0 ? Number(cardsBelow[0].rankingField) : NaN;
      if (!isNaN(prevRankingField) && !isNaN(nextRankingField)) {
         droppedCard.rankingField = prevRankingField + 1 > nextRankingField ? prevRankingField : nextRankingField;
      } else if (!isNaN(prevRankingField)) {
         droppedCard.rankingField = prevRankingField + 1;
      } else if (!isNaN(nextRankingField)) {
         droppedCard.rankingField = nextRankingField - 1 < 1 ? nextRankingField: nextRankingField -1;
      }
    }
  }


  hasColRepChanged(oldArray, newArray){
    if(oldArray.length != newArray.length){
      return true
    }
    for (let i = 0; i < oldArray.length; i++) {
      if (oldArray[i].documentId !== newArray[i].documentId) {
        console.log(true)
          return true;
      }
    }
     return false;
  }
  processElasticQuery() {
    const filter = this.processHandlebars(this.componentDefinition.filter, this.document);
    if (typeof filter === 'string') {
      this.options.filter = JSON.parse(filter.replace(/'/g, '"'));
    } else {
      this.options.filter = filter;
    }
  }

  generateId(columnIndex, groupIndex) {
    return `${groupIndex}-${columnIndex}-${uuid.v4()}`;
  }
  extractIndex(id) {
    let indexArray = id.split('-');
    return [Number(indexArray[0]), Number(indexArray[1])];
  }
  processHandlebars(handlebar, doc) {
    let handlebarsContext = {
      document: doc,
      doc: doc,
      tpl: this.template,
      template: this.template,
      componentDefinition: this.componentDefinition,
    };
    let defaultHelpers = sclHandlebars.defaultHelpers();
    return sclHandlebars.processHandlebarsV2(handlebar, null, handlebarsContext, defaultHelpers);
  }

  rankDocs(docs) {
    let unRankedDocuments = docs.filter((doc) => this.rankExpression(doc.rankingField, false));
    let rankedDocuments = docs
      .filter((doc) => this.rankExpression(doc.rankingField, true))
      .sort((a, b) => Number(a.rankingField) - Number(b.rankingField));

    return [...rankedDocuments, ...unRankedDocuments];
  }

  rankExpression(rank, hasRanks) {
    const numRank = Number(rank);
    if (isNaN(numRank)) return hasRanks ? false : true;

    return hasRanks ? numRank !== 0 : numRank === 0;
  }

  editRankField(cardId) {
    this.editingCardId = cardId;
    this.cdr.detectChanges();
  }

  saveRankField(doc, rank, column, grpIndex, colIndex) {
    if (rank !== doc.rankingField) {
      doc.rankingField = rank;
      let prevColumnRep = [...column.docs]
      if (this.gridColumns && this.gridColumns[colIndex] && this.gridColumns[colIndex].sort) {
        this.sort(column.docs, this.gridColumns[colIndex].sort);
      }
       
       let rankedDocs = this.rankDocs(column.docs);

       if(this.cardTableSave && this.hasColRepChanged(prevColumnRep, rankedDocs)){
        this.valueChanged(this.groups)
       }
   
      this.groups[grpIndex].columns[colIndex] = {
        colId: this.generateId(grpIndex, colIndex),
        colHeader: column.colHeader,
        docs: rankedDocs,
        collapsible: column.collapsible,
        connectedLists: this.findConnectedLists(grpIndex)
      };
     }
    this.editingCardId = null;
    this.cdr.detectChanges();
  }

  onDragStarted(card: any): void {
    this.currentDragId = card.documentId
    this.dragDelayElapsed = false;
    this.dragTimeout = setTimeout(() => {
      this.dragDelayElapsed = true;
      this.cdr.detectChanges()
    }, this.delayedDragging);
    this.cdr.detectChanges()
  }
  clearDragTimeout(){
    clearTimeout(this.dragTimeout);
    this.currentDragId = null; 
  }
  
  ngOnDestroy(): void {
    this.subs.unsubscribe();
    if (this.dragTimeout) {
      clearTimeout(this.dragTimeout);
    }
  }

}
